// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_pa-0";
export var discountCodeInput = "_pa-1";